document.addEventListener('DOMContentLoaded', () => {
  function initCustomSortSelect() {
    let customSelectWrappers = document.querySelectorAll('.custom-select');
    
    if (!customSelectWrappers.length) return;
    
    customSelectWrappers.forEach((customSelectWrapper) => {
      let defaultSelect = customSelectWrapper.querySelector('select');
      let customSelectLabel = customSelectWrapper.querySelector('.select-selected');
      
      if (!defaultSelect || customSelectLabel) return;
      
      customSelectLabel = document.createElement('DIV');
      
      customSelectLabel.setAttribute('class', 'select-selected default');

      if (customSelectWrapper.dataset.type !== 'fixed') {
        customSelectLabel.innerHTML = defaultSelect.options[defaultSelect.selectedIndex].innerHTML;
      } else {
        customSelectLabel.innerHTML = defaultSelect.options[0].innerHTML;
      }
      
      customSelectLabel.addEventListener("click", function(e) {
        e.stopPropagation();

        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
      
      customSelectWrapper.appendChild(customSelectLabel);
      
      let customSelect = document.createElement('DIV');
      
      customSelect.setAttribute('class', 'select-items select-hide');
      
      for (i = 1; i < defaultSelect.options.length; i++) {
        let customSelectOption = document.createElement('DIV');
        
        customSelectOption.innerHTML = defaultSelect.options[i].innerHTML;
        customSelectOption.setAttribute('data-value', defaultSelect.options[i].value);

        if (defaultSelect.selectedIndex == i) {
          customSelectOption.setAttribute('class', 'same-as-selected');
        }
        
        customSelectOption.addEventListener('click', function(e) {
          for (j = 0; j < defaultSelect.options.length; j++) {
            if (defaultSelect.options[j].value == this.dataset.value) {
              const event = new Event('input', {
                'bubbles': true,
                'cancelable': true
              });
              
              defaultSelect.dispatchEvent(event)
              
              defaultSelect.selectedIndex = j;
              
              if (customSelectWrapper.dataset.type !== 'fixed') {
                customSelectLabel.innerHTML = this.innerHTML;
              }
    
              let activeCustomSelectOptions = this.parentNode.querySelectorAll('same-as-selected');
              
              if (activeCustomSelectOptions.length) {
                activeCustomSelectOptions.forEach((activeCustomSelectOption) => {
                  activeCustomSelectOption.removeAttribute('class');
                });
              }
              
              this.setAttribute('class', 'same-as-selected');
              
              break;
            }
          }
          
          customSelectLabel.click();
        });
        
        customSelect.appendChild(customSelectOption);
      }
      
      customSelectWrapper.appendChild(customSelect);
    });
  }
  
  initCustomSortSelect();

  document.addEventListener('collectionfilterapplied', () => {
    initCustomSortSelect();
  });
});